"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _useReactlyticsHandlers = _interopRequireDefault(require("./useReactlyticsHandlers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withReactlyticsHandler = function withReactlyticsHandler(handlerNameSet) {
  return function (WrappedComponent) {
    var AnalyticsWrapper = function AnalyticsWrapper(props) {
      var newProps = (0, _useReactlyticsHandlers.default)(props, handlerNameSet); // eslint-disable-next-line react/jsx-props-no-spreading

      return _react.default.createElement(WrappedComponent, newProps);
    };

    var AnalyticsWrapperWithStatics = (0, _hoistNonReactStatics.default)(_react.default.memo(AnalyticsWrapper), WrappedComponent);
    AnalyticsWrapperWithStatics.displayName = "withReactlyticsHandler(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return AnalyticsWrapperWithStatics;
  };
};

var _default = withReactlyticsHandler;
exports.default = _default;